module.exports = __webpack_public_path__ + "img/vol03_cup02_label02.61345fc1.png";